import { useTracking } from '@change-corgi/core-react/tracking';

type Result = ModelHookResult<
	undefined,
	{
		onCardDetailsFieldFocus: () => void;
		onFieldFocusIban: () => void;
	}
>;

export function useFieldFocus(): Result {
	const track = useTracking();

	const onCardDetailsFieldFocus = () => {
		void track('sponsor_cc_update_focus_card_details');
	};
	const onFieldFocusIban = () => {
		void track('sponsor_cc_update_focus_iban');
	};

	return {
		actions: {
			onCardDetailsFieldFocus,
			onFieldFocusIban,
		},
	};
}
